module.exports = __webpack_public_path__ + "media/images/logo_en-46d5fc62adf1a69f77e10064258c61b5.svg";